// extracted by mini-css-extract-plugin
export default {"space":"GjDa6T8jogOFTQcWoJrG","addIdentifier":"_0YvWkgqFYs8X0wAAwk5k","placeHolderShimmer":"EtEbAEOQEIsQJhOISw3I"};